// removed by extract-text-webpack-plugin
module.exports = {"Breadcrumbs":"_1sHkyVUlprFPW1f-yApDX8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Breadcrumbs/styles.css
// module id = 672
// module chunks = 0